import { render, staticRenderFns } from "./Almacenes.vue?vue&type=template&id=67627720&scoped=true"
import script from "./Almacenes.vue?vue&type=script&lang=ts"
export * from "./Almacenes.vue?vue&type=script&lang=ts"
import style0 from "./Almacenes.vue?vue&type=style&index=0&id=67627720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67627720",
  null
  
)

export default component.exports